import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=91f55714&"
import script from "./NotesDialog.vue?vue&type=script&lang=ts&"
export * from "./NotesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports